import { createRequestHelper } from '@utils/swr'
import { type PartnerProfileRequest } from '../types/apiRequest'
import { type PartnerProfileResponse } from '../types/apiResponse'
import { type FortuneApis } from '../types/apis'

const {
  useRequest,
} = createRequestHelper<FortuneApis['get']['partnerProfile'], PartnerProfileResponse, PartnerProfileRequest>({
  client: 'fortune',
  key: params => params?.code
    ? `/campaigns/${params.code}/partner/profile`
    : null,
  isImmutable: true,
})

export const useApiPartnerProfile = useRequest
